module.exports = "<div class=\"header--tabs\"> <md-tabs data-e2e=\"Header_Tabs\" md-selected=\"$ctrl.currentTab\" md-no-pagination=\"{{!$ctrl.isMobile}}\" id=\"tabs\" class=\"md-tabs vln-center-tabs-scroll\" md-center-tabs md-dynamic-height> <md-tab ng-repeat=\"item in $ctrl.tabs\" ui-sref=\"{{item.state}}\" gtm-click-event=\"{{$ctrl.gtmId}}-myappsTab\" md-on-select=\"$ctrl.onTabChange($ctrl.currentTab)\"> <md-tab-label>{{item.title}}</md-tab-label> </md-tab> </md-tabs> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/pageHeader/tabs/tabs.html
// module id = 1442
// module chunks = 28